import React from 'react';
import { MapPin } from 'lucide-react';

export const Header = () => {
  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="header-top-content">
            <div className="header-info-items">
              <a 
                href="https://maps.google.com/?q=Piazza+Gioberti+4B+Via+Emilia+Santo+Stefano+22E+Reggio+Emilia" 
                target="_blank" 
                rel="noopener noreferrer"
                className="header-info-item header-info-link"
              >
                <MapPin className="w-4 h-4" />
                <span>Piazza Gioberti 4/B, angolo Via Emilia S.S. 22/E</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <nav className="nav">
        <div className="container">
          <div className="nav-content">
            <div className="nav-logo">
              <span className="logo-text">Tabaccheria N.16</span>
            </div>
            
            <div className="nav-links">
              <a href="#svapo" className="nav-link">Svapo</a>
              <a href="#services" className="nav-link">Servizi</a>
              <a href="#contact" className="nav-link">Contatti</a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};
